import React from "react";

function Footer() {
  return (
    <div className="footer">
      <p id="footer">&copy; 2024 Justina Ominisan</p>
      
    </div>
  );
}

export default Footer;
